<template>
  <div>
    <a href="#" @click="$bvModal.show('modalCompartilhar')">
      <i class="fas fa-share-alt" data-toggle="tooltip" data-placement="bottom" title="Compartilhar"></i>
    </a>

    <b-modal hide-footer id="modalCompartilhar" body-class="modal-conteudo" header-class="">
      <template slot="modal-title">
        <h5 class="modal-title" id="modalCompartilharLabel">Compartilhar esse tópico</h5>
      </template>
      <div class="row my-5">
        <div class="col-12 col-md-6">
          <div class="valid-feedback" v-html="mensagem">
          </div>
          <div class="d-flex align-items-center mb-3 copy-indique">
            <input type="text" readonly class="form-control-plaintext pl-2" id="staticEmail2" :value="linkCompartilhamento">
            <button type="button" class="btn" data-toggle="tooltip" data-placement="top" title="Copie o link!" v-clipboard:copy="linkCompartilhamento" v-clipboard:success="onCopy"><i
              class="fas fa-copy"></i></button>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="text-center social-indique">
            <p>Compartilhe nas suas redes</p>
            <div class="d-flex align-items-center justify-content-center pr-3 pl-3 pl-md-0 mt-2">
              <a target="_blank" :href="linkWhatsApp" data-toggle="tooltip" data-placement="top" title="WhatsApp"><i
                class="fab fa-whatsapp"></i></a>
              <a target="_blank" :href="linkFacebook" data-toggle="tooltip" data-placement="top" title="Facebook"><i
                class="fab fa-facebook-f"></i></a>
              <a target="_blank" :href="linkEmail" data-toggle="tooltip" data-placement="top" title="Email"><i
                class="fas fa-envelope"></i></a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true

Vue.use(VueClipboard)

export default {
  name: 'CompartilharTopicoSalaAula',
  data () {
    return {
      success: null,
      dismissCountdown: 0,
      mensagem: '&nbsp'
    }
  },
  props: {
    linkCompartilhamento: {
      type: String,
      required: true
    }
  },
  computed: {
    linkWhatsApp: function () {
      return `https://wa.me/?text=Jaleko Recomenda - Acesse ${this.linkCompartilhamento}`
    },

    linkFacebook: function () {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.linkCompartilhamento}&src=sdkpreparse`
    },

    linkEmail: function () {
      return 'mailto:'
    }
  },
  methods: {
    onCopy: function (e) {
      this.dismissCountdown = 3
      this.mensagem = 'Copiado!'
      setTimeout(() => {
        this.mensagem = '&nbsp;'
      }, 2000)
    },

    countdownChanged (dismissCountDown) {
      this.dismissCountdown = dismissCountDown
    }
  }
}
</script>

<style scoped>
  .valid-feedback {
    display: block;
  }
</style>
